const React = require("react");
const {LayoutAuthWithDesc} = require("../../../layouts");
const ButtonAccept = require("../../../dumb/Button/Accept");
const {Link} = require("../../../../router");
const {LINK_SECURITY_VERIFICATION} = require("../../../../constants/links");

module.exports = () => {
  return (
    <LayoutAuthWithDesc
      title="Reset security verification"
      description={(
        <div>
          <b>
            I lost my Google 2FA reset code, how can I get it back?
          </b>
          <br/><br/>

          I can access a device that was set up with the Google 2FA reset code.
          <br/><br/>

          We suggest you disable Google Authenticator on your Lunu account first,
          then enable it again using your new device. Remember to save your
          reset code this time.
          <br/><br/>

          <b>
            I can&apos;t access a device that was set up with the Google 2FA
            reset code
          </b>
          <br/><br/>

          Please confirm request to our Support to get a new code.
        </div>
      )}
      control={(
        <ButtonAccept
          className="w"
          href="mailto:support@lunu.io"
        >
          Confirm request
        </ButtonAccept>
      )}
      additional={(
        <Link
          href={LINK_SECURITY_VERIFICATION}
          className="c5B47FF olN tdU dn f12 fw3 o70:h"
        >
          Return to 2FA
        </Link>
      )}
    />
  );
};
